const teamCompare = (a, b) => {
    if (a.name < b.name) {
        return -1;
    }
    if (a.name > b.name) {
        return 1;
    }
    return 0;
}


export const createTeamGroups = (data) => {
    let groups = {
        "Americas": [],
        "EMEA": [],
        "Pacific": [],
        "China": []
    }

    for (const obj of data) {
        const region = obj.region
        groups[region].push({ ...obj, value: (obj.id).toString(), label: obj.name })
    }

    for (const key of Object.keys(groups)) {
        groups[key].sort(teamCompare)
    }

    let teams = []

    for (const key of Object.keys(groups)) {
        teams.push({ group: key, items: groups[key] })
    }

    return teams
}


const playerCompare = (a, b) => {
    if (a.group < b.group) {
        return -1;
    }
    if (a.group > b.group) {
        return 1;
    }
    return 0;
}

export const createPlayerGroups = (data) => {
    let groups = {}
    for (const obj of data) {
        const teamName = obj.Team.name
        if (teamName in groups) groups[teamName].push({ ...obj, value: (obj.id).toString(), label: obj.name })
        else groups[teamName] = [{ ...obj, value: (obj.id).toString(), label: obj.name }]
    }

    let players = []

    for (const key of Object.keys(groups)) {
        players.push({ group: key, items: groups[key] })
    }

    players.sort(playerCompare)

    return players
}
